<template>
  <div class="float-chat">
    <div class="chat d-flex align-items-end justify-content-end">
      <div v-if="showChatContainer" class="chat-content">
        <div class="align-items-end chat-float-loader">
          <div v-for="conversation in conversations" :key="conversation.id">
            <chat-conversation
                :conversation="conversation"
                :authid="authid"
            />
          </div>
        </div>
      </div>
      <div class="chat-list">
        <div class="ml-4 mr-2 pr-1 pb-1">
          <a href="#" class="btn btn-primary btn-pill" @click.prevent="openChatGroupList">
            <i class="far fa-comment"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { eventBus } from "../../utils/helpers";
import { getFloatingChatRooms, isFloating } from "../../services/api/uni-chat";
import ChatConversation from "./ChatConversation.vue";

export default {
  name: "ChatContainer",
  components: { ChatConversation },
  props: {
    authid: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      conversations: []
    }
  },
  created() {
    this.showChatConversations()
  },
  mounted() {
    eventBus.$on('open-chat-room', () => {
      this.showChatConversations()
    });

    eventBus.$on('close-chat-room', (room_id) => {
      this.conversations = this.conversations.filter(
        conversation => conversation.id !== room_id
      );
    });
  },
  computed: {
    ...mapState("chat", ["chatRooms", "showChatContainer"])
  },
  watch: {
    async chatRooms(rooms) {
      this.conversations = [...rooms];

      if (this.conversations.length > 0) {
        this.SET_SHOW_CHAT_CONTAINER(true);
      } else {
        this.SET_SHOW_CHAT_CONTAINER(false);
      }
    }
  },
  methods: {
    ...mapMutations("chat", ["SET_CHAT_ROOMS", "SET_SHOW_CHAT_CONTAINER"]),

    async showChatConversations() {
      try {
        const rooms = await getFloatingChatRooms('1');
        this.SET_CHAT_ROOMS(rooms.data);

        if (this.chatRooms.length > 0) {
          this.SET_SHOW_CHAT_CONTAINER(true);
        } else {
          this.SET_SHOW_CHAT_CONTAINER(false);
        }
      } catch (error) {
        console.error('Error fetching chat conversations:', error);
      }
    },
    openChatGroupList() {
      eventBus.$emit('open-chat-group-list', true);
    }
  }
}
</script>